export default __webpack_public_path__ + "static/monikaHalan1-803b8fd103e2bd06a9e160b5f28b878f.jpg";